import React from 'react';
import { Input, InputProps } from 'reactstrap';

type ToggleSwitchSize = 'sm' | 'md' | 'lg';
type ToggleSwitchLabelPosition = 'start' | 'end';

interface ToggleSwitchProps extends Omit<
  InputProps,
  'type' | 'size' | 'onChange'
> {
  id: string;
  checked: boolean;
  label?: React.ReactNode;
  size?: ToggleSwitchSize;
  labelPosition?: ToggleSwitchLabelPosition;
  gap?: number | string;
  gapClassName?: string;
  wrapperClassName?: string;
  switchClassName?: string;
  labelClassName?: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}

const sizeClassMap: Record<ToggleSwitchSize, string> = {
  sm: 'form-switch-sm',
  md: 'form-switch-md',
  lg: 'form-switch-lg',
};

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  id,
  checked,
  label,
  size = 'md',
  labelPosition = 'start',
  gap,
  gapClassName = 'gap-3',
  wrapperClassName = '',
  switchClassName = '',
  labelClassName = '',
  onChange,
  ...inputProps
}) => {
  const labelNode = label ? (
    <label
      className={`fs-13 mb-0 text-nowrap ${labelClassName}`.trim()}
      htmlFor={id}
    >
      {label}
    </label>
  ) : null;

  return (
    <div
      className={`d-inline-flex align-items-center ${gapClassName} ${wrapperClassName}`.trim()}
      style={gap !== undefined ? { gap } : undefined}
    >
      {labelPosition === 'start' ? labelNode : null}
      <div
        className={`form-check form-switch ${sizeClassMap[size]} mb-0 ${switchClassName}`.trim()}
      >
        <Input
          {...inputProps}
          id={id}
          type="switch"
          role="switch"
          checked={checked}
          onChange={onChange}
        />
      </div>
      {labelPosition === 'end' ? labelNode : null}
    </div>
  );
};

export default ToggleSwitch;
